import { css } from '@emotion/react'
import { Modal, ModalProps } from 'bold-ui'
import { useMemo } from 'react'
import { mediaMobile } from 'util/breakpoints'

// TODO@CODEBENDERS levar a responsividade deste modal para o Modal do Bold, que alcança também os modais imperativos (information/confirm) bold#1015
export function ResponsiveModal(props: Readonly<ModalProps>) {
  const { style, wrapperStyle, ...rest } = props

  const styles = useMemo(
    () => ({
      wrapper: css`
        ${mediaMobile} {
          padding: 0;
          width: 100%;
          height: 100%;
        }
        ${wrapperStyle}
      `,
      modal: css`
        ${mediaMobile} {
          height: 100%;
          max-height: 100%;
          min-width: min-content;
          width: 100%;
        }
      `,
    }),
    [wrapperStyle]
  )

  return <Modal {...rest} wrapperStyle={styles.wrapper} style={css(styles.modal, style)} />
}
